export const STORAGE_KEYS = {
  authToken: () => 'token',
  authUsername: () => 'username',
  locale: () => 'mh-house-locale',
  project: projectId => `mh-structure-design_${projectId || 'default'}`,
  projectVersions: projectId => `${STORAGE_KEYS.project(projectId)}_versions`,
  projectIndex: () => 'mh-structure-design_project-index',
  inputDraft: idempotencyKey => `mh-floorplan-input-draft_${idempotencyKey || 'default'}`,
  structureDraft: projectKey => `mh-structure-design-draft_${projectKey || 'default'}`,
  aiDesignTaskRegistry: () => 'mh-ai-design-task-registry_v1',
  aiGenerationDiagnosticsIndex: () => 'mh-ai-generation-diagnostics-index_v1',
  aiGenerationDiagnosticsArtifact: artifactId => `mh-ai-generation-diagnostics-artifact_v1_${artifactId}`
}
